export default __webpack_public_path__ + "static/media/telegram.be2fb33b.png";